// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__PQizK","productName":"Table_productName__NwPpX"};